var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M9.06053 7.99999L16.0605 0.999991L14.9999 -0.0606689L7.99987 6.93933L0.999869 -0.0606689L-0.060791 0.999991L6.93921 7.99999L-0.060791 15L0.999869 16.0607L7.99987 9.06065L14.9999 16.0607L16.0605 15L9.06053 7.99999Z","fill":"#181818"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"d":"M0 0H16V16H0V0Z","fill":"white"})))]);
}

Close.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close;

Close.default = Close;
